import Moment from "react-moment";
import { t } from "i18next";
import DatePickerIcon from "../common/datePickerIcon";
import { useSelector } from "react-redux";
import { updateSelectedDay, updateSelectedTimeslotId } from "../../redux/reducer/prenotationViewReducer";
import { useAppDispatch } from "../../redux";

/**
 * Display a day (date without time) in a descriptive format (i.e. Sabato, 17 giugno 2023)
 * and a datepicker where to change the selected day.
 */
const TitleDay = () => {
  // redux state
  const { selectedDay } = useSelector((state: any) => state.prenotationView);
  const { dateFilter } = useSelector((state: any) => state.prenotation);
  let paramsDateSelect: any[] = dateFilter.map((value: any) => value._id).filter((params: any) => params !== undefined);
  const dispatch = useAppDispatch();

  /**
   * Datepicker date change.
   * @param day - Selected day returned from date picker.
   */
  const onDayChange = (day: string) => {
    // update redux state
    dispatch(updateSelectedDay(day))
    // reset timeslot selection, the first one will be opened
    dispatch(updateSelectedTimeslotId(''))
  }

  return (
    <div className="TitleDay">
      {((selectedDay) ?
        <div className="row m-0">
          <div className="col-10">
            <h6><b> <Moment format="dddd">{selectedDay}</Moment></b>, <Moment format="D MMMM YYYY">{selectedDay}</Moment></h6>
          </div>

          <div className="col-2 text-right">
            <DatePickerIcon
              date={new Date(selectedDay)}
              handleChange={onDayChange}
              showDates={paramsDateSelect}
            />
          </div>
        </div>
        :
        <></>)}
    </div>
  )
}

export default TitleDay